import { WORKFLOW_FIELDS } from '../fragments'

export default `
  ${WORKFLOW_FIELDS}
  mutation restorePreviousWorkflowVersion($projectId: String!, $input: RestorePreviousWorkflowVersionInput!) {
    restorePreviousWorkflowVersion(projectId: $projectId, input: $input) {
      ...WorkflowFields
    }
  }
`
